import src from "IMAGE";
export default { src, width: 197, height: 99, blurWidth: 8, blurHeight: 4, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAECAYAAACzzX7wAAAATElEQVR42m3MMQrAMAwDwDwt5AvZ8mN79GaDH2JjUGlpszSahDjU8KaqoKoQEWTmntvX3B1rLfTeH/QDZoYxBuacZ3DfEhGYGRGxwQWi3HK4c9YNYAAAAABJRU5ErkJggg=="};
